export default function StoreBoot() {
  return (
    <div
      className="store-boot"
      role="status"
      aria-busy="true"
      aria-label="Carregando"
    />
  );
}
